import { ArrowUpRight, FileDown } from "lucide-react";
import { Reveal, EASE } from "./motion";
import { Logo } from "./Nav";
import { IMAGES } from "./content";
import { motion } from "framer-motion";

export const CtaFooter = ({ onContact, onDeck }) => (
  <>
    <section id="contato" className="relative overflow-hidden bg-dm-ink py-24 dm-noise md:py-32">
      {/* glow */}
      <div className="pointer-events-none absolute inset-0 -z-0 opacity-70">
        <div className="absolute -bottom-24 left-1/2 h-[420px] w-[820px] -translate-x-1/2 rounded-[50%] bg-dm-guita blur-[120px] opacity-40" />
      </div>

      <div className="relative z-10 mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-5 md:px-8 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <motion.div
            initial={{ scale: 0.94, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: EASE }}
            className="overflow-hidden rounded-[2.5rem] border-4 border-white/10"
          >
            <img
              src={IMAGES.kidSinging}
              alt="Criança cantando no microfone de brinquedo"
              className="h-full w-full object-cover"
            />
          </motion.div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-display text-5xl font-black leading-[0.92] tracking-tighter text-dm-cream md:text-6xl lg:text-7xl">
              Vamos colocar a DóRéMigos no{" "}
              <span className="dm-rainbow-text">mundo real?</span>
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-dm-cream/70">
              Buscamos parceiros de licenciamento, editoras, redes de varejo e operadores de
              shopping para escalar publishing, softlines e experiências presenciais.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="mt-9 flex flex-wrap gap-4">
              <button
                onClick={onContact}
                data-testid="cta-talk-team"
                className="group inline-flex items-center gap-2 rounded-full bg-dm-guita px-7 py-4 text-base font-bold text-white transition-transform duration-300 hover:scale-[1.04]"
              >
                Falar com o time
                <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
              <button
                onClick={onDeck}
                data-testid="cta-receive-deck"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-4 text-base font-semibold text-dm-cream transition-colors duration-300 hover:bg-white/10"
              >
                <FileDown className="h-5 w-5" />
                Receber o deck
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>

    <footer className="relative bg-dm-cream pt-16">
      <div className="h-1.5 w-full bg-dm-guita" />
      <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-5 px-5 py-16 text-center md:px-8">
        <Logo />
        <p className="max-w-md text-base text-dm-muted">
          Música, amizade e imaginação para o desenvolvimento real das crianças.
        </p>
        <p className="mt-4 text-sm text-dm-muted/70">
          © {new Date().getFullYear()} DóRéMigos. Todos os direitos reservados.<br/>• LAB2513 Tech & Design Studio •<br/>
        </p>
      </div>
    </footer>
  </>
);
